var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClassData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.401,
    height: 44.7,
    viewBox: "0 0 35.401 44.7",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.784 -4.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.784,4.66v44.7h35.4V4.66ZM9.318,21.276a5.141,5.141,0,0,1,2.811-4.566,4.057,4.057,0,1,1,4.633,0,5.138,5.138,0,0,1,2.807,4.566v2.831H9.321ZM37.7,34.174H10.381a.967.967,0,1,1-.069-1.932H37.7a.967.967,0,0,1,0,1.931Zm0-5.126H10.381a.967.967,0,1,1-.069-1.932H37.7a.967.967,0,0,1,0,1.931Zm0-5.126H24.678a.968.968,0,0,1,0-1.936H37.7a.968.968,0,0,1,0,1.936Zm0-5.128H24.678a.967.967,0,1,1-.069-1.932H37.7a.967.967,0,0,1,0,1.931Zm0-5.126H24.678a.967.967,0,1,1-.069-1.932H37.7a.967.967,0,0,1,0,1.931Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassData);
export default __webpack_public_path__ + "static/media/class-data.aff91c47.svg";
export { ForwardRef as ReactComponent };